'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('focus')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/focus.js
// module id = 659
// module chunks = 3